module.exports = __webpack_public_path__ + "static/media/img2.fa95e933.jpg";